import { render, staticRenderFns } from "./TranInscripcionList.vue?vue&type=template&id=51aca05d&"
import script from "./TranInscripcionList.vue?vue&type=script&lang=js&"
export * from "./TranInscripcionList.vue?vue&type=script&lang=js&"
import style0 from "./TranInscripcionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports